<template >
  <div class="modifyDialog">
    <el-dialog title="修改调用资源量上限基数" :visible.sync="modifyDialogVisible" width="600px">
      <!-- {{rowData.apiResourceDto}} -->
      <el-form ref="modifyForm" :model="modifyForm" :rules="rules" label-width="140px">
        <el-form-item label="资源名称">
          <span class="mf16" v-if="rowData">{{rowData.apiResourceDto.name}}<span v-if="rowData.apiResourceDto.resourceType === 1">普通</span><span v-if="rowData.apiResourceDto.resourceType === 2">精品</span>接口</span>
        </el-form-item>
        <el-form-item label="每日接口调用上限"  class="is-required" prop="maxInvokePerDay">
          <el-input v-model.number="modifyForm.maxInvokePerDay" ></el-input>
        </el-form-item>
        <el-form-item label="每日去重下载上限"  class="is-required" prop="maxDownloadPerDay">
          <el-input  v-model.number="modifyForm.maxDownloadPerDay" :disabled="rowData.apiResourceDto.id === 1"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="doit()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">

import devService from '../../../../service/devService'

export default {
  props: {
    rowData: {
      type: Object
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      loading: false,
      modifyForm: {
      },
      resourceData: this.$props.rowData,
      rules: {
        maxInvokePerDay: [
          { type: 'number', required: true, message: '请输入每日接口调用上限数', trigger: ['blur', 'change'] }
        ],
        maxDownloadPerDay: [
          { type: 'number', required: true, message: '请输入每日调用上限数', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    doit () {
      this.loading = true
      this.$refs['modifyForm'].validate(async valid => {
        // 验证通过
        if (valid) {
          try {
            await devService.invokeNum(this.rowData.id, this.modifyForm)
            // 重置表单
            this.$refs.modifyForm.resetFields()
            // 保存对象
            this.$emit('success')
            this.loading = false
            this.modifyDialogVisible = false
          } catch (e) {
            this.$message.error(e && e.msg)
            this.loading = false
          }
        }
        this.loading = false
      })
    }
  },
  watch: {
    modifyDialogVisible (newVal, oldVal) {
      console.log(this.rowData)
      if (newVal) {
        if (this.$refs.modifyForm) {
          this.$refs.modifyForm.resetFields()
        }
        this.modifyForm = {}
        this.modifyForm = {
          maxInvokePerDay: this.$props.rowData.maxInvokePerDay,
          maxDownloadPerDay: this.$props.rowData.maxDownloadPerDay
        }
      }
    }
  },
  computed: {
    modifyDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>

</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/interface-manage/modify-dialog/index.vue